var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-4",attrs:{"min-height":_vm.height}},[_c('apexChart',{attrs:{"max-width":"530","type":"donut","options":_vm.charOptionsComputed,"series":_vm.commercialsSells.quantities}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }